import {track} from '@amplitude/analytics-browser';
import {useCallback} from 'react';

export type BaseEvent<EventName, EventData = undefined> = {
  name: EventName;
  data: EventData;
};

export type SimpleEvent<EventName> = {
  name: EventName;
};

export type AmplitudeEvent = {
  name: string;
  data?: Record<string, unknown>;
};

export const useLogEvent = () => {
  const logEvent = useCallback((event: AmplitudeEvent) => {
    const {name, data} = event;
    if (data) {
      track(name, data);
    } else {
      track(name);
    }
  }, []);
  return logEvent;
};
